import { authSelectors } from '../../app/auth/auth.selectors';
import { settingsSelectors } from '../../app/resource/settings/settings.selectors';
import { userSelectors } from '../../app/resource/user/user.selectors';
import { userTenantsSelectors } from '../../app/resource/user-tenants/user-tenants.selectors';
import { useSelect, useSelectWithParams } from '../selector.utils';

export function useTenantBranding() {
  const userId = useSelect(authSelectors.selectLoggedUser);
  const user = useSelectWithParams(userSelectors.selectResourceById, userId ?? '');
  const tenant = useSelectWithParams(userTenantsSelectors.selectResourceById, user?.tenantId ?? '');
  const settings = useSelect(settingsSelectors.selectCurrentSettings);

  const tenantName = tenant?.name ?? user?.tenantName ?? '';

  return {
    iconLogo: settings?.iconLogo,
    tenantName,
  };
}
